import { ListValidationError } from '../types/types';

export function formatListValidationError(error: ListValidationError): string {
    const title = error.title ?? 'Validation error';
    const keys = error.errors?.invalidKeys ?? [];

    if (!keys.length) return title;

    const formattedKeys = keys.map(key => `- ${key}`).join('\n');
    return `${title}\n\n${formattedKeys}`;
}
